import { OptionListName } from '@navstation-portal/reporting/data-model/ui';
import { BALLAST_CODE_OPTIONS } from '@navstation-portal/reporting/data-model/vessel-report';
import { SelectOption } from '@navstation-portal/shared/data-model/common';
import { tvaTimezoneToSelectOption } from '@navstation-portal/shared/util/time';
import { convertCodeToOption } from './convert-code-to-option';

/**
 * Turns the text TVA stores for a select field into the option the control
 * holds, one converter for each list an `option` node can name.
 *
 * Each converter is the one the tab store's init uses for the same field, so a
 * carried value and an initialised value are the same option.
 */
const OPTION_LISTS: Record<OptionListName, (text: string) => SelectOption | undefined> = {
  timezone: tvaTimezoneToSelectOption,
  ballastCode: (text) => convertCodeToOption(text, BALLAST_CODE_OPTIONS),
};

/**
 * Gives the option of the named list that the text names, or undefined.
 *
 * The template arrives as JSON, so a list name the client does not know can
 * reach here, and it gives undefined.
 */
export function toOption(options: OptionListName, text: unknown): SelectOption | undefined {
  const convert = Object.prototype.hasOwnProperty.call(OPTION_LISTS, options) ? OPTION_LISTS[options] : undefined;
  if (convert === undefined) return undefined;
  return convert(text as string);
}
